<template>
    <qmWxBtn>
        <div class="top-prize__main">
            <div class="top-prize__main-content">
                <div class="top-prize__cards">
                    <div class="top-prize__card top-prize__card--vote" @click="showPrizePop(0)">
                        <img :src="store.prizeImg[0]" alt="">
                        <p class="top-prize__label">{{ store.pageData?.vote_task_info?.[0]?.status == 1 ? '已获得' : '投票达1票' }}</p>
                    </div>
                    <div class="top-prize__card top-prize__card--vote" @click="showPrizePop(1)">
                        <img :src="store.prizeImg[1]" alt="">
                        <p class="top-prize__label">{{ store.pageData?.vote_task_info?.[1]?.status == 1 ? '已获得' : '投票达50票' }}</p>
                        <div class="img-dongtai"></div>
                    </div>
                    <div class="top-prize__card top-prize__card--sign">
                        <img class="top-prize__card__sign-img" src="@/assets/images/wish_img_allcard.png" alt="">
                        <div class="top-prize__sign-text">
                            <img src="@/assets/images/wish_img_signature.png" alt="">
                            <p class="top-prize__sign-desc">对应作品投票超过50票可在投票结束后获得</p>
                        </div>
                    </div>
                </div>
                <div class="top-prize__banner">
                    <!-- <div class="top-prize__banner-icon">
                        <img class="img-jiang" src="@/assets/images/img-jiang.png" alt="">
                    </div> -->
                    <div class="top-prize__banner-content">
                        <p>参与投票，即有机会收到官方邀约，与偶像作家零距离接触！受邀粉丝更有全程免单（往返+住宿）福利！</p>
                    </div>
                </div>
            </div>
        </div>
    </qmWxBtn>
</template>

<script lang="ts" setup>
import qmWxBtn from '@common/components/qm-wx-btn.vue';
import { useStore } from '../store';
import { handleLogin } from '@common/assets/ts/utils';
import { useStoreCommon } from '@common/store/common';
const storeCommon = useStoreCommon();
const store = useStore();

const showPrizePop = (num: number) => {
    if (!handleLogin(storeCommon.userInfo.user_type.toString())) return;
    if (store.pageData?.vote_task_info?.[num]) {
        store.setPrizePopData({
            show: true,
            data: [{
                type: 1,
                ...store.pageData?.vote_task_info?.[num],
                img_url: store.prizeImg[num],
                status: store.pageData?.vote_task_info?.[num]?.status == 1 ? 1 : 0,
                title: store.pageData?.vote_task_info?.[num]?.status == 1
                    ? `催更大魔王${num == 0 ? '' : '·动态'}（90天）`
                    : `投票达${num == 0 ? 1 : 50}票可获得`,
            }],
        });
    }
};
</script>

<style lang="scss" scoped>

.top-prize__main {
    width: 672px;
    height: 266px;
    margin: 0 auto;
    background: rgba(253,240,193,0.2);
    border-radius: 24px;
    padding: 12px;
    position: relative;
    border: 0.5px solid rgba(251, 219, 127, 0.4);
    // &::before {
    //     content: '';
    //     position: absolute;
    //     top: -0.5px;
    //     left: -0.5px;
    //     width: calc(100% + 1px);
    //     height: calc(100% + 1px);
    //     border-radius: 24px;
    //     z-index: -1;
    //     background: linear-gradient(180deg, rgba(255, 252, 238, 1), rgba(255, 252, 238, 0));
    // }
    .top-prize__main-content {
        position: relative;
        z-index: 10;
    }
}

.top-prize__cards {
    display: flex;
    align-items: center;
    z-index: 10;
}

.top-prize__card {
    position: relative;
    border-radius: 20px;
    padding: 10px;
    z-index: 10;
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient( 313deg, #FFF4C4 0%,#FFFBE7 100%);
        opacity: 0.5;
        z-index: -1;
        border-radius: 20px;
    }
    &:not(:last-child) {
        margin-right: 12px;
    }
    &--vote {
        img {
            width: 110px;
            height: 110px;
        }
    }

    &--sign {
       display: flex;
       align-items: center;
       padding: 20px 18px 18px 22px;
    }
    &__sign-img {
        width: 140px;
        margin-right: 20px;
    }

    .top-prize__label {
        font-size: 18px;
        color: rgba(73,2,2,0.7);
        line-height: 26px;
        text-align: center;
    }
}

.top-prize__sign-text {
    flex: 1;
    img {
        width: 152px;
    }
}

.top-prize__sign-desc {
    font-size: 16px;
    color: rgba(73,2,2,0.5);
    line-height: 22px;
    word-break: break-all;
    margin-top: 10px;
}

.top-prize__sign-headline {
    border: 2px dashed rgba(232, 92, 44, 0.6);
    border-radius: 8px;
    padding: 8px 12px;
    margin-bottom: 10px;
    display: inline-block;
}

.top-prize__sign-title {
    font-size: 28px;
    color: #E85C2C;
    font-weight: bold;
    margin: 0 0 4px;
    line-height: 1.3;
}

.top-prize__sign-subtitle {
    font-size: 26px;
    color: #333;
    font-weight: bold;
    margin: 0;
    line-height: 1.3;
}

/* 底部横幅 */
.top-prize__banner {
    display: flex;
    align-items: center;
    margin-top: 12px;
}

.top-prize__banner-icon {
    width: 72px;
    height: 72px;
    // background: rgba(255, 244, 196, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    .img-jiang {
        width: 60px;
    }
}

.top-prize__banner-content {
    flex: 1;
    font-size: 22px;
    color: rgba(255,255,255,0.8);
    line-height: 32px;
    text-align: left;
    word-break: break-all;
    padding: 0 4px;
}
.img-dongtai {
    position: absolute;
    top: 0;
    right: 0;
}
</style>
